export const setQuoteDataAction = (data) => {
  return function (dispatch) {
    dispatch({
      type: 'SET_QUOTE_DATA',
      payload: data,
    });
  };
};

export const addValueAction = (type, heading, option) => {
  return function (dispatch) {
    dispatch({
      type: 'UPDATE_VALUE',
      payload: { type, heading, option },
    });
  };
};

export const deleteValueAction = (deleteType, deleteHeading, index) => {
  return function (dispatch) {
    dispatch({
      type: 'DELETE_VALUE',
      payload: { deleteType, deleteHeading, index },
    });
  };
};

export const addQuoteImageAction = (data) => {
  return function (dispatch) {
    dispatch({
      type: 'ADD_QUOTE_IMAGE',
      payload: data,
    });
  };
};
